import { loadOptions } from '../../versa/formset.js';

export default function (...args)
{
	return {
		options: [
			{ value: '10', label: 'Aberta'    },
			{ value: '20', label: 'Lacrada'   },
			{ value: '30', label: 'Cancelada' },
		],
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		}
	};
}
